import axios from 'axios';
import { fetchUsersSuccess, fetchUsersFailure } from './userSlice';
import { API_BASE_URL } from '../config/config';

export const fetchUsers = () => async (dispatch, getState) => {
    try {
      const { token } = getState().user; // Get token from Redux state
  
      if (!token) {
        throw new Error("No token found");
      }
  
      // Fetch users using the token from Redux state
      const response = await axios.get(`${API_BASE_URL}api/users/users`, {
        headers: { Authorization: `Bearer ${token}` }, // Send JWT token in headers
      });
  
      if (response.data && response.data.users) {
        // Dispatch the fetched users to Redux store
        dispatch(fetchUsersSuccess(response.data.users));
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      // Dispatch failure action with error message
      dispatch(fetchUsersFailure(error.response?.data?.message || 'Failed to fetch users'));
    }
  };
